export default __webpack_public_path__ + "static/media/gm.a47487be.jpg";